import { configureStore } from "@reduxjs/toolkit";
import localforage from 'localforage';
import thunk from "redux-thunk";
import { types } from "../types/types";

import { rootReducer } from "../reducers/rootReducer";

//redux-persist
import { persistReducer, persistStore } from 'redux-persist';


const middlewares = [];
middlewares.push(thunk);

//console.log( "--->store--->process.env.REACT_APP_LOGGIN_MODE", process.env.REACT_APP_LOGGIN_MODE );

if (process.env.REACT_APP_LOGGIN_MODE === `on`) {
  //const { logger, createLogger } = require(`redux-logger`);
  const { createLogger } = require(`redux-logger`);

  const logger = createLogger({
    // ...options
    collapsed: (getState, action, logEntry) => !logEntry.error,
    predicate: (getState, action) => action.type !== types.AUTH_START_TOKEN_RENEW,
    duration: true,
    timestamp: true,
    logger: console, // implementation of the `console` API.
    logErrors: true,
    level: "log",
  });
  middlewares.push(logger);
}

//Configure redux-persist
const persistConfig = {
    key: 'root',
    //storage,
    storage: localforage,
    version: 1,
    //whitelist: ['user'], // In this example, we persist the 'user' reducer
  }

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  //reducer: rootReducer, //Este funcionaba
  reducer: persistedReducer, //Nueva configuracion redux-persist
  //middleware: [thunk, logger],
  middleware: middlewares,
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
});

export const persistor = persistStore(store);